import { useRef, useEffect } from 'react';

const Translate = props => {
	const { formIndex, includedLanguages } = props;
	const googleTranslateRef = useRef(null);

	const allowedLangList = includedLanguages && includedLanguages != "" ? { 'includedLanguages' :  includedLanguages } : {};

	// useEffect(() => {

    //     // const addScript = document.createElement('script');
    //     // addScript.setAttribute(
    //     //     'src',
    //     //     '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    //     // );
    //     // document.body.appendChild(addScript);
    //     // debugger
    //     // window.googleTranslateElementInit = () => {
    //     //     new window.google.translate.TranslateElement(
    //     //         {
    //     //             pageLanguage: 'en',
    //     //             includedLanguages: 'en,es',//here include all languages that you need
    //     //         },
    //     //         'google_translate_element'
    //     //     );
    //     // };

	// 	let intervalid;

    //     const checkGoogleTranslate = () => {
    //     	if (googleTranslateRef.current) {
	//         	if (window.google && window.google.translate) {
	//         		googleTranslateRef.current.innerHTML = "";
    //     			clearInterval(intervalid);
    //     			console.log(googleTranslateRef.current);

	//         		//window.googleTranslateElementInit = () => {
	// 	        		new window.google.translate.TranslateElement(
	// 	        			{ pageLanguage: 'en', includedLanguages: 'en,es', layout : window.google.translate.TranslateElement.InlineLayout.SIMPLE },
	// 		                googleTranslateRef.current
	// 		            );
	//         		//}

	//         		// Call googleTranslateElementInit after script is loaded
    //       			//window.googleTranslateElementInit();
	//         	}
    //     	// } else {
    //     	// 	// Call googleTranslateElementInit after script is loaded
    //       	// 	window.googleTranslateElementInit();
    //     	}
    //     }

    //     intervalid = setInterval(checkGoogleTranslate, 100);
    // }, [formIndex]);

    useEffect(() => {
	    var addScript = document.createElement('script');
	    addScript.setAttribute(
	      'src',
	      '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
	    );
	    document.body.appendChild(addScript);
	    window.googleTranslateElementInit = googleTranslateElementInit;
	}, []);

	const googleTranslateElementInit = () => {
	    new window.google.translate.TranslateElement(
	      {
	        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
	        ...allowedLangList
	      },
	      googleTranslateRef.current
	    );
	};

    return (
    	<div>
    		<div ref={googleTranslateRef}></div>
    	</div>
    );
};

export default Translate;